import { AppNS } from 'app';
import { Params } from 'app/types';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import { useEffect, useState } from 'react';

import { DISCIPLINES } from '../disciplines-picker/validation-schema';

export const DISCIPLINES_WITH_EXCLUDED_FIELDS: AppNS.DisciplineId[] = [
  'elevator',
  'boilerWelder',
  'boilerInspection',
  'buildingCommissioning',
  'buildingLeakage',
];

export const getDisciplinesWithExcludedFields = () => {
  // Excluded disciplines for Pricing policy are:
  // - DISCIPLINES_WITH_EXCLUDED_FIELDS
  // - and all that parent is `planReview`
  const PLAN_REVIEW_DISCIPLINES = DISCIPLINES.filter((discipline) => discipline.parent === 'planReview').map(
    (discipline) => discipline.id
  );

  return [...DISCIPLINES_WITH_EXCLUDED_FIELDS, ...PLAN_REVIEW_DISCIPLINES];
};

/**
 * Check if current disciplines have excluded fields for Pricing policy.
 * @param disciplines
 * @returns
 */
export const isFieldsExcluded = (disciplines: string[]) => {
  return !disciplines.some(
    (discipline) => !getDisciplinesWithExcludedFields().includes(discipline as AppNS.DisciplineId)
  );
};

export const validateData = (data: Params): string[] => {
  let errors: string[] = [];
  if (!data.documentsState) {
    errors.push('Please check documents data');
  }

  if (!data.acknowledgementsState) {
    errors.push('Please check necessary acknowledgements');
  }

  if (!data.termsState) {
    errors.push('Please agree to terms');
  }

  if (data.disciplines && data.disciplines.length === 0) {
    errors.push('Please pick some disciplines');
  }

  if (!data.pricingPolicyState) {
    errors.push('Please check pricing policy (Proposal or Cost Per Inspection Form)');
  }

  if (!data.invoiceDataState) {
    errors.push('Please check invoice data');
  }

  return errors;
};

export interface SectionValidationProps {
  isSubmitted: boolean;
  documentsState: boolean;
  termsState: boolean;
  disciplines: string[];
  acknowledgementsState: boolean;
  pricingPolicyState: boolean;
  invoiceDataState: boolean;
}

export default function SectionValidation(props: SectionValidationProps) {
  const {
    isSubmitted,
    documentsState,
    termsState,
    disciplines,
    acknowledgementsState,
    pricingPolicyState,
    invoiceDataState,
  } = props;

  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  useEffect(() => {
    setValidationErrors(
      validateData({
        termsState,
        documentsState,
        disciplines,
        acknowledgementsState,
        pricingPolicyState,
        invoiceDataState,
      })
    );
  }, [documentsState, disciplines, termsState, acknowledgementsState, pricingPolicyState, invoiceDataState]);

  if (!isSubmitted) {
    return null;
  }

  return (
    <>
      {validationErrors.length > 0 && isSubmitted && (
        <ErrorsList errors={validationErrors} title="Please fill all required information" />
      )}
    </>
  );
}
